import React from 'react';
export const themeType = document.documentElement.getAttribute('data-bs-theme') || 'light';

const styleBadge1 = {
  borderRadius: '5px 0 0 5px'
};
const styleBadge2 = {
  borderRadius: '0 5px 5px 0'
};

const SplitBadge = ({ text1, text2 }) => {
  if (!text1 && !text2) return null;
  const badge1Class = 'text-bg-secondary';
  const badge2Class = themeType === 'light' ? 'text-bg-light' : 'bg-light-subtle';
  if (!text1) return <span className={`badge me-1 ${badge2Class}`}>{text2}</span>;
  if (!text2) return <span className={`badge me-1 ${badge1Class}`}>{text1}</span>;

  return (
    <span className="badgeContainer me-1 text-nowrap">
      <span className={`badge ${badge1Class}`} style={styleBadge1}>
        {text1}
      </span>
      <span className={`badge ${badge2Class}`} style={styleBadge2}>
        {text2}
      </span>
    </span>
  );
};

export default SplitBadge;
